var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41992 0.583252L10.2132 1.64842C10.4798 1.70792 10.6699 1.94417 10.6699 2.21775V8.0435C10.6699 9.21367 10.0848 10.3068 9.11125 10.9555L5.41992 13.4166L1.72859 10.9555C0.754422 10.3063 0.169922 9.21367 0.169922 8.04409V2.21775C0.169922 1.94417 0.360089 1.70792 0.626672 1.64842L5.41992 0.583252ZM5.41992 1.7785L1.33659 2.68559V8.0435C1.33659 8.82342 1.72626 9.552 2.37551 9.98484L5.41992 12.0148L8.46434 9.98484C9.11359 9.552 9.50325 8.824 9.50325 8.04409V2.68559L5.41992 1.77909V1.7785ZM8.01692 4.79609L8.84234 5.62092L5.13001 9.33325L2.65492 6.85817L3.47975 6.03334L5.12942 7.683L8.01692 4.7955V4.79609Z",
    fill: "#173963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.a26fdf3097f49fcc3bd38a59ad1aeefa.svg";
export { ForwardRef as ReactComponent };